import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide10 = ({ t, total, onActive }) => {
  return (
    <SlideShell theme="emissor"
      index={9}
      total={total}
      label="Control Tower"
      kicker={t.kicker}
      onActive={onActive}
      variant="plain"
      bgStyle={{
        "--slide-bg": "linear-gradient(112deg,#020202,#06110d 54%,#020202),radial-gradient(820px 560px at 68% 56%,rgba(216,182,46,.18),transparent 70%)"
      }}
    >

      <h2>{t.title}</h2>
      
      <p className="lead">{t.body}</p>

      <div className="grid four wide">
        <div className="card">
          <span className="num">01</span>
          <h3>{t.c1Title}</h3>
          <p>{t.c1Body}</p>
        </div>
        <div className="card">
          <span className="num">02</span>
          <h3>{t.c2Title}</h3>
          <p>{t.c2Body}</p>
        </div>
        <div className="card">
          <span className="num">03</span>
          <h3>{t.c3Title}</h3>
          <p>{t.c3Body}</p>
        </div>
        <div className="card">
          <span className="num">04</span>
          <h3>{t.c4Title}</h3>
          <p>{t.c4Body}</p>
        </div>
      </div>
    </SlideShell>
  );
};





